import {
  ADD_EMPLOYEE_FAMILY_TYPE_FAIL,
  ADD_EMPLOYEE_FAMILY_TYPE_SUCCESS,
  ADD_EMPLOYEE_FAMILY_TYPE_REQUEST,
  DELETE_EMPLOYEE_FAMILY_TYPE_REQUEST,
  DELETE_EMPLOYEE_FAMILY_TYPE_SUCCESS,
  GETDETAIL_EMPLOYEE_FAMILY_TYPE_REQUEST,
  GETDETAIL_EMPLOYEE_FAMILY_TYPE_FAIL,
  GETDETAIL_EMPLOYEE_FAMILY_TYPE_SUCCESS,
  UPDATE_EMPLOYEE_FAMILY_TYPE_FAIL,
  UPDATE_EMPLOYEE_FAMILY_TYPE_SUCCESS,
  UPDATE_EMPLOYEE_FAMILY_TYPE_REQUEST,
  DELETE_EMPLOYEE_FAMILY_TYPE_FAIL,
  GETALL_EMPLOYEE_FAMILY_TYPE_FAIL,
  GETALL_EMPLOYEE_FAMILY_TYPE_SUCCESS,
  GETALL_EMPLOYEE_FAMILY_TYPE_REQUEST,
  CLEAR_EMPLOYEE_FAMILY_RECORD,
} from "../constant/EmployeeFamilyTypeConstant";

const initialState = {
  loading: false,
  action: "Employee_Family_Type",
  result: [],
  success: false,
  singledata: [],
  message: "",
  error: "",
};

const EmployeeFamilyTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_EMPLOYEE_FAMILY_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETALL_EMPLOYEE_FAMILY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data.list,
        message: action.message,
      };
    case GETALL_EMPLOYEE_FAMILY_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    case GETDETAIL_EMPLOYEE_FAMILY_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETDETAIL_EMPLOYEE_FAMILY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GETDETAIL_EMPLOYEE_FAMILY_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case ADD_EMPLOYEE_FAMILY_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_EMPLOYEE_FAMILY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case ADD_EMPLOYEE_FAMILY_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };

    case UPDATE_EMPLOYEE_FAMILY_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_EMPLOYEE_FAMILY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),

        message: action.message,
      };
    case UPDATE_EMPLOYEE_FAMILY_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };

    case DELETE_EMPLOYEE_FAMILY_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_EMPLOYEE_FAMILY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),

        message: action.message,
      };
    case DELETE_EMPLOYEE_FAMILY_TYPE_FAIL:
      return {
        ...state,
        loading: true,
        error: action.error,
        message: action.message,
      };
    case CLEAR_EMPLOYEE_FAMILY_RECORD:
      return {
        ...state,
        loading: false,
        result: [],
        singledata: [],
        message: action.message,
      };
    default:
      return state;
  }
};

export default EmployeeFamilyTypeReducer;
